import { ApiProperty } from "@nestjs/swagger";

export class RMGrnItemIdReq{
    @ApiProperty()
    grnItemId:number;
}